import { Observable } from 'rxjs';
import { DashboardData } from '../models/dashboard-data.model';

export abstract class DashboardApiPort {
  abstract getDashboardData(): Observable<DashboardData>;
}
